import TimeSpan from './time_span.vue'

export default TimeSpan
